// src/api/emoticons.js

import api from "./axios";

export const getMyEmoticons = async () => {
    try {
        const { data: emData } = await api.get("/api/rewards/emoticons/my/");

        let list = [];
        if (Array.isArray(emData)) {
            list = emData;
        } else if (emData) {
            const keys = ["emoticons", "items", "results", "data", "list"];
            for (const k of keys) {
                const v = emData?.[k];
                if (Array.isArray(v)) { list = v; break; }
            }
        }

        // ✅✅✅ 이 부분이 핵심입니다! ✅✅✅
        // '껍데기' 배열(list)을 순회하며 '알맹이'(item.emoticon)만 꺼내서 새 배열을 만듭니다.
        const finalList = list.map(item => {
            // MinihomeEditor가 기대하는 'value' 속성을 만들어줍니다.
            const value = item.emoticon.image || item.emoticon.emoji_text || '';

            // 순수 emoticon 데이터에 value와 is_equipped 같은 추가 정보를 합쳐서 반환합니다.
            return {
                ...item.emoticon, // name, image, emoji_text 등 알맹이 데이터
                value: value,    // Select Box에서 사용할 값
                is_equipped: item.is_equipped, // 장착 여부 정보
            };
        });

        console.log("[API:getMyEmoticons] 최종 반환 데이터:", finalList);
        return finalList;

    } catch (e) {
        console.warn("getMyEmoticons API 호출 또는 파싱 실패", e);
        return [];
    }
};